export default __webpack_public_path__ + "static/media/step1regis.ab21bda2.svg";